import { render } from "./newProductType.vue?vue&type=template&id=75c03dad&scoped=true"
import script from "./newProductType.vue?vue&type=script&lang=js"
export * from "./newProductType.vue?vue&type=script&lang=js"

import "./newProductType.vue?vue&type=style&index=0&id=75c03dad&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c03dad"]])

export default __exports__